<svg:svg preserveAspectRatio="xMaxYMax meet"
         style="margin: auto; background: transparent; display: block; shape-rendering: auto;"
         [attr.width]="pxSvgWidth"
         [attr.height]="pxSvgHeight">
    <svg:g [attr.transform]="gaugePos">
        <svg:rect [attr.width]="pxOuterWidth"
                  [attr.height]="pxGaugeHeight"
                  [attr.rx]="radius"
                  [attr.fill]="backColor"
                  [attr.stroke]="backColor"
                  stroke-width="0.25px"
                  x="0"
                  y="0"></svg:rect>
        <svg:rect id="innerGauge"
                  width="0"
                  [attr.height]="pxGaugeHeight"
                  [attr.rx]="radius"
                  [attr.fill]="foreColor"
                  [attr.stroke]="backColor"
                  stroke-width="0.25px"
                  x="0"
                  y="0">
        </svg:rect>
        <svg:text [attr.transform]="leftLegendPos"
                  [attr.dx]="radius / 2"
                  [attr.dy]="-14"
                  [attr.fill]="fontColor"
                  class="left-legend">
            {{ leftLegend }}
        </svg:text>
        <svg:text [attr.transform]="rightLegendPos"
                  [attr.dx]="(-1 * radius) / 2"
                  [attr.dy]="-14"
                  [attr.fill]="fontColor"
                  class="right-legend">
            {{ rightLegend }}
        </svg:text>
    </svg:g>
</svg:svg>
